import type { SongMeta } from '@/types';
import { sunnyMeowSong } from './songs/sunnyMeow';
import { midnightSnackSong } from './songs/midnightSnack';
import { goldenSong } from './songs/golden';
import { aptSong } from './songs/apt';

/** Song registry. Add a new SongMeta object and list it here to make it selectable
 * everywhere (Song Select screen, gameplay loader) with no other code changes. */
export const SONGS: SongMeta[] = [sunnyMeowSong, midnightSnackSong, goldenSong, aptSong];

export function getSongById(id: string): SongMeta {
  const song = SONGS.find((s) => s.id === id);
  if (!song) throw new Error(`Unknown song id: ${id}`);
  return song;
}
